'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = saveItem;
/**
 * Save or update an item.
 *
 * @example
 * const obj = { id: 21, title: 'Mr.Beet' };
 * saveItem('List', obj, (item) => {
 *     item.set_item('Id', obj.id);
 *     item.set_item('Title', obj.title);
 * });
 *
 * @param {string}	 list Name of list
 * @param {Object}	 item Object to save. Object.Id is used to fetch existing when updating
 * @param {function(sp_item: Object):} assigner Function for assigning data to the SP list item
 *
 * @return {Promise<Object>} saved object.
 */
function saveItem(list, item, assigner) {
    var Id = item.Id;


    return new Promise(function (resolve, reject) {
        window.SP.SOD.executeFunc('sp.js', 'SP.ClientContext', function () {
            var ctx = window.SP.ClientContext.get_current();

            var path = window._spPageContextInfo.webAbsoluteUrl + '/Lists/' + list;
            var sharepointItem = void 0;
            if (Id) {
                sharepointItem = ctx.get_web().getList(path).getItemById(Id);
            } else {
                sharepointItem = ctx.get_web().getList(path).addItem(new window.SP.ListItemCreationInformation());
            }

            assigner(sharepointItem);
            sharepointItem.update();
            ctx.load(sharepointItem, 'Id');
            ctx.executeQueryAsync(function () {
                var result = _extends({}, item);
                result.Id = sharepointItem.get_id();
                resolve(result);
            }, function (sender, args) {
                reject(sender, args);
            });
        });
    });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/saveItem.js
// module id = 1042
// module chunks = 0